import { Stack, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const AccordionSection = ({ title, isOpen, onToggle, children }) => (
  <Stack>
    <Button
      endIcon={isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      onClick={onToggle}
      sx={{
        color: '#000',
        textTransform: 'uppercase',
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 1,
      }}
    >
      {title}
    </Button>
    <Stack
      style={{
        display: isOpen ? 'flex' : 'none',
      }}
    >
      {children}
    </Stack>
  </Stack>
);
